import axios from "axios";
import { BASE_URL, USER_MEDALS_URL } from "../util/constants";
import DashboardParams from "../interfaces/dashboardParams";
import UserMedal from "../interfaces/userMedal";

const useApiDashboard = () => {
    const axiosInstance = axios.create({
        baseURL: BASE_URL
    });

    const listHistory = (token: string, params: DashboardParams) => {
        return axiosInstance
            .post<UserMedal[]>(`${USER_MEDALS_URL}/history/${token}`, params)
            .then((res) => res.data)
            .catch((err) => {
                handleError(err);
                throw err;
            });
    }

    const handleError = (err: any) => {
        console.log("Error occurred: ", err);

        if (err.response) {
        console.log("Requisition returned with error:");
        console.log("Response: ", err.response.data);
        console.log("Status: ", err.response.status);
        } else if (err.request && err.config) {
        console.log("Requisition was done but didn't had server answer:");
        console.log("URL: ", err.config.baseURL);
        console.log("Method: ", err.config.method);
        console.log("URL requested: ", err.config.url);
        } else {
        console.log("Error message: ", err.message);
        }
    };

    return { listHistory };
}

export default useApiDashboard;